module.exports = __webpack_public_path__ + "img/mail.0f4853b0.png";